var map = {
	"./flags/en.svg": 1002,
	"./flags/es.svg": 1003,
	"./flags/fr.svg": 1004,
	"./flags/it.svg": 1005,
	"./flags/nl.svg": 1006,
	"./flags/pt.svg": 1007,
	"./icons/icon-arrow-down.svg": 157,
	"./icons/icon-arrow-up.svg": 158,
	"./icons/icon-beach--green.svg": 1008,
	"./icons/icon-beach--red.svg": 1009,
	"./icons/icon-beach.svg": 1010,
	"./icons/icon-break.svg": 1011,
	"./icons/icon-chevron-circle-left--white.svg": 1012,
	"./icons/icon-chevron-circle-left.svg": 1013,
	"./icons/icon-chevron-circle-right--white.svg": 1014,
	"./icons/icon-chevron-circle-right.svg": 1015,
	"./icons/icon-chevron-left--white.svg": 1016,
	"./icons/icon-info--circle.svg": 1017,
	"./icons/icon-legend-buoys.svg": 1018,
	"./icons/icon-legend-star.svg": 1019,
	"./icons/icon-legend-swell-arrow.svg": 1020,
	"./icons/icon-legend-swell.svg": 1021,
	"./icons/icon-legend-wind.svg": 1022,
	"./icons/icon-loader.svg": 1023,
	"./icons/icon-point--green.svg": 1024,
	"./icons/icon-point--red.svg": 1025,
	"./icons/icon-point.svg": 1026,
	"./icons/icon-reef--green.svg": 1027,
	"./icons/icon-reef--red.svg": 1028,
	"./icons/icon-reef.svg": 1029,
	"./icons/icon-river--green.svg": 1030,
	"./icons/icon-river--red.svg": 1031,
	"./icons/icon-river.svg": 1032,
	"./icons/icon-sandbar--green.svg": 1033,
	"./icons/icon-sandbar--red.svg": 1034,
	"./icons/icon-sandbar.svg": 1035,
	"./icons/icon-thumbs-down-solid.svg": 1036,
	"./icons/icon-thumbs-up-solid.svg": 1037,
	"./icons/icon-tidal-range--blue.svg": 1038,
	"./icons/icon-tide-clock--color.svg": 1039,
	"./icons/icon-tide-needle.svg": 1040,
	"./icons/icon-tide-star.svg": 1041,
	"./logos/apple-logo--black.svg": 95,
	"./logos/apple-logo--white.svg": 1042,
	"./logos/google-g-logo.svg": 96,
	"./logos/outside-logo--black.svg": 1043,
	"./logos/outside-logo--white.svg": 1044,
	"./logos/surf-forecast__logo--black.svg": 1045,
	"./logos/surf-forecast__logo--clear.svg": 1046,
	"./logos/surf-forecast__logo--white.svg": 1047,
	"./logos/surf-forecast__logo.svg": 1048
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1001;